import React from "react";

import { Checkbox, Text } from "@performyard/py-components";
import type { Option } from "@performyard/py-components/src/types/Option";

export type FormOption = {
	baseId: string;
	name: string;
};

export const createRenderFormOption = (formsById: Map<string, FormOption>) => {
	const RenderFormOption = (option: Option<string>, selected: boolean, onToggle: () => void) => {
		const formBaseId = option.value;
		const form = formsById.get(formBaseId);
		const optionId = `option-${formBaseId}`;

		return (
			<div className="flex h-full min-w-0 items-center gap-2 px-3">
				<Checkbox id={optionId} checked={selected} onCheckedChange={onToggle} />
				<div className="flex min-w-0 flex-1 items-center gap-2">
					<Text
						size="paragraph-3"
						weight="regular"
						color="neutral-9"
						overrideElement="label"
						htmlFor={optionId}
						wrap={false}
						dangerouslySetClassName="min-w-0 cursor-pointer truncate"
					>
						{form?.name ?? option.label}
					</Text>
				</div>
			</div>
		);
	};
	return RenderFormOption;
};
